import coreStore from "./core-store";

const remoteResource = 'reconciliation/api/v1/queries';

const store = coreStore.searchQueryStore(coreStore.createCoreStore('reconciliationQuery', remoteResource, 'reconciliationQueries'))

export default store;